import React from 'react';

export default props => {
    return ( 
        <button class="arrow left">
          <svg width={props.width || '10px'} height={props.height || '13px'} viewBox="0 0 50 80">
            <polyline fill="none" stroke={props.color || '#2472B9'} stroke-width="8" stroke-linecap="round" stroke-linejoin="round" points="
            45.63,75.8 0.375,38.087 45.63,0.375 "/>
          </svg>  
        </button>
    );
}


// WEBPACK FOOTER //
// ./src/images/Arrow.js